module.exports = __webpack_public_path__ + "static/media/house-return.eff4f36e.svg";